module.exports = __webpack_public_path__ + "static/media/bse.017212f9.jpg";